module.exports = __webpack_public_path__ + "images/DPB2_4.ca9b629134159bef09bdbb27a6a00f17.png";